export const TIPS_MODES = ["node", "discretize"] as const;
export type TipsMode = (typeof TIPS_MODES)[number];
